import { render, staticRenderFns } from "./OrdersRefundsTable.vue?vue&type=template&id=0f8246e6"
import script from "./OrdersRefundsTable.vue?vue&type=script&lang=js"
export * from "./OrdersRefundsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports